import * as React from "react";

import styles from '../BannerEditor/Banners.module.less'
import ResizeableMonacoEditor, {IResizeableMonacoEditorProps} from "../BannerEditor/ResizeableMonacoEditor";
import {monacoTheme} from "../../constants/monaco";
import {IFileData} from "../../store/files/filedata/types";
import {Button} from "antd";
import {FileTypeMap} from "./constants";

interface IOwnProps {
    size?: number;
    activeKey?: string;
    originalFileData?: IFileData
    activeFileData: IFileData
    fileType?: string;
}

interface ICallbackProps {
    onFileDataChange?: (data: string) => void;
}

export type IFileDataProps = IOwnProps & ICallbackProps

interface IState {
}

class FileData extends React.PureComponent<IFileDataProps, IState> {
    state: IState = {};

    render() {
        let fileType = this.props.fileType ? this.props.fileType : 'html';
        if (FileTypeMap[fileType]) {
            fileType = FileTypeMap[fileType]
        }
        let editorProps: IResizeableMonacoEditorProps = {
            value: this.props.activeFileData.data,
            language: fileType,
            theme: monacoTheme,
            size: this.props.size,
            active: this.props.activeKey
        };

        if (this.props.originalFileData) {
            editorProps.onDiffChange = this.props.onFileDataChange
            editorProps.onChange = this.props.onFileDataChange
            editorProps.original = this.props.originalFileData.data
            editorProps.diffMode = true
            editorProps.diffEditorProps = {
                options: {
                    ignoreTrimWhitespace: false,
                    renderSideBySide: true,
                    originalEditable: false
                }
            }
        } else {
            editorProps.onChange = this.props.onFileDataChange
        }


        return (
            <div className={styles.templateTab}>
                <ResizeableMonacoEditor {...editorProps} />
            </div>
        )
    }
}

export default FileData;

